import { CSSObject } from '@emotion/react';
import { useTheme } from '@doxyme/ui-foundation/theme';
import { type ModalFooterProps } from './modalFooter';

export type ModalFooterStyles<T> = Record<
  'container' | 'buttons' | 'backButton' | 'caption' | 'buttonContainer',
  T
>;

export const useModalFooterStyles = ({
  layout,
}: {
  layout?: ModalFooterProps['layout'];
}): ModalFooterStyles<CSSObject> => {
  const theme = useTheme();

  return {
    container: {
      display: 'flex',
      padding: theme.spacing(6),
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(3),
      width: '100%',
    },
    buttonContainer: {
      display: 'flex',
      gap: theme.spacing(4),
      width: '100%',
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: layout === 'equal-buttons' ? 'stretch' : 'center',
      gap: theme.spacing(4),
      flex: '1 0 0',
      width: '100%',
      flexDirection: layout === 'equal-buttons' ? 'column' : undefined,
    },
    backButton: {
      flexGrow: 0,
    },
    caption: {
      textAlign: 'center',
      color: theme.text.generic.tertiary,
    },
  };
};
